import { ErrorHandler, Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { ENV_PROD_BUILD } from '@y42/environment';
import { ErrorHandlerService } from './error-handler.service';
import { FullStoryModule } from './full-story/full-story.module';
import { ENABLE_SENTRY, SentryModule } from './sentry/sentry.module';
import { SentryService } from './sentry/sentry.service';

@NgModule({
  imports: [SentryModule, FullStoryModule],
})
export class ErrorHandlerModule {
  static forRoot(): ModuleWithProviders<ErrorHandlerModule> {
    return {
      ngModule: ErrorHandlerModule,
      providers: [
        {
          provide: ENABLE_SENTRY,
          useFactory: (production: boolean) => production,
          deps: [ENV_PROD_BUILD],
        },
        {
          provide: ErrorHandler,
          useFactory: getErrorHandler,
          deps: [ENABLE_SENTRY, SentryService, Injector, ENV_PROD_BUILD],
        },
      ],
    };
  }
}

export function getErrorHandler(
  enableSentry: boolean,
  sentry: SentryService,
  injector: Injector,
  production: boolean,
): ErrorHandler {
  if (enableSentry) {
    if (!production) {
      console.warn('[Sentry]: using Sentry exception capturing in local development');
    }
    return new ErrorHandlerService(sentry, injector);
  }

  return new ErrorHandler();
}
